// База українських державних свят і пам'ятних днів на 2025-2026 роки
export const ukrainianHolidays = {


  // Листопад 2025

  "2025-11-16": {
    name: "Всесвітній день рукоділля",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-16": {
    name: "День працівників сільського господарства України",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-16": {
    name: "Всесвітній день рукоділля",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-16": {
    name: "Всесвітній День ґудзиків",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-17": {
    name: "Міжнародний день студентів та День студента в Україні",
    type: "educational",
    category: "Освітні свята"
  },
  "2025-11-18": {
    name: "День сержанта Збройних Сил України",
    type: "military",
    category: "Військові свята"
  },
  "2025-11-18": {
    name: "День ангела Романа",
    type: "religious",
    category: "Релігійні свята"
  },
  "2025-11-19": {
    name: "Міжнародний день чоловіків",
    type: "international",
    category: "Міжнародні дні"
  },
  "2025-11-19": {
    name: "Міжнародний день жінок-підприємців",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-19": {
    name: "День працівників гідрометеорологічної служби",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-19": {
    name: "День працівника скляної промисловості",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-20": {
    name: "День захисту дітей в Україні",
    type: "national",
    category: "Національні свята"
  },
  "2025-11-20": {
    name: "День педіатра",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-20": {
    name: "День соціального підприємництва",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-20": {
    name: "Міжнародний день відмови від паління",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-21": {
    name: "Всесвітній день рибальства",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-21": {
    name: "День Гідності та Свободи",
    type: "national",
    category: "Національні свята"
  },
  "2025-11-21": {
    name: "Всесвітній день вітань",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-22": {
    name: "Міжнародний день музиканта",
    type: "cultural",
    category: "Культурні свята"
  },
  "2025-11-22": {
    name: "День пам’яті жертв голодоморів",
    type: "national",
    category: "Національні свята"
  },
  "2025-11-22": {
    name: "Міжнародний день сина",
    type: "national",
    category: "Національні свята"
  },
  "2025-11-23": {
    name: "Міжнародний день імідж-консультанта",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-23": {
    name: "Всесвітній день акварелі",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-24": {
    name: "Всесвітній день моржа",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-24": {
    name: "Всесвітній день еволюції",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-25": {
    name: "День ангела Петра",
    type: "religious",
    category: "Релігійні свята"
  },
  "2025-11-26": {
    name: "Міжнародний день чоботаря",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-26": {
    name: "День фітнесу та здорового харчування",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-27": {
    name: "День шпильок та голок",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-27": {
    name: "День подяки В США",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-28": {
    name: "Міжнародний день системного інженера",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-28": {
    name: "Чорна п’ятниця",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-28": {
    name: "День працівника системи фінансового моніторингу в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-29": {
    name: "День електронних привітань та листівок",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-29": {
    name: "Міжнародний день жінок-правозахисників",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-29": {
    name: "День «Клієнт не завжди правий»",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-30": {
    name: "Міжнародний день спідниць",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-30": {
    name: "Всесвітній день домашніх тварин",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-11-30": {
    name: "Андрія Первозваного",
    type: "religious",
    category: "Релігійні свята"
  },
  "2025-11-30": {
    name: "День захисту інформації",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-11-30": {
    name: "День радіотехнічних військ Повітряних Сил Збройних Сил України",
    type: "military",
    category: "Військові свята"
  },
  





  // Грудень 2025

"2025-12-01": {
  name: "Міжнародний день невролога",
  type: "professional",
  category: "Професійні свята"
},
  "2025-12-01": {
    name: "Національний день підтримки жінок",
    type: "family",
    category: "Сімейні свята"
  },
  "2025-12-01": {
    name: "День різдвяних вогнів",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-02": {
  name: "Міжнародний день модельної залізниці",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-03": {
  name: "День - Зробіть подарунок",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-03": {
  name: "Всесвітній день катання на ковзанах",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-03": {
  name: "Міжнародний день людей з інвалідністю",
  type: "international",
  category: "Міжнародні дні"
},
"2025-12-04": {
    name: "День ракетних військ і артилерії України",
    type: "military",
    category: "Військові свята"
  },
  "2025-12-04": {
    name: "Міжнародний день банків",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-12-04": {
    name: "День надзвичайних відзнак трудового колективу",
    type: "professional",
    category: "Професійні свята"
  },
  "025-12-04": {
    name: "День печива",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-05": {
  name: "Міжнародний день волонтера",
  type: "international",
  category: "Міжнародні дні"
},
"2025-12-05": {
    name: "День працівників статистики та аналітики в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-12-05": {
    name: "День подяки бармену",
    type: "professional",
    category: "Професійні свята"
  },
  "2025-12-05": {
    name: "День ангела Сави",
    type: "religious",
    category: "Релігійні свята"
  },
"2025-12-06": {
  name: "День Збройних Сил України",
  type: "military",
  category: "Військові свята"
},
"2025-12-06": {
  name: "День святого Миколая Чудотворця за юліанським календарем",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-06": {
    name: "День іграшки для дітей",
    type: "family",
    category: "Сімейні свята"
  },
  "2025-12-06": {
    name: "День свічки",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-07": {
    name: "Міжнародний день цивільної авіації",
    type: "professional",
    category: "Професійні свята"
  },
"2025-12-07": {
    name: "День української хустки",
    type: "national",
    category: "Національні свята"
  },
"2025-12-07": {
  name: "День ангела Павла",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-07": {
    name: "День написання листів",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-08": {
    name: "День брауні",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-08": {
    name: "День сала",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-09": {
  name: "Міжнародний день боротьби з корупцією",
  type: "international",
  category: "Міжнародні дні"
},
"2025-12-09": {
  name: "Міжнародний день ветеринарної медицини",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-09": {
    name: "День Анни",
    type: "religious",
    category: "Релігійні свята"
  },
"2025-12-09": {
    name: "День різдвяної листівки",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-09": {
    name: "Всесвітній день техно-музики",
    type: "cultural",
    category: "Культурні свята"
  },
"2025-12-10": {
  name: "День прав людини",
  type: "international",
  category: "Міжнародні дні"
},
"2025-12-10": {
    name: "Всесвітній день футболу",
    type: "sports",
    category: "Спортивні свята"
  },
"2025-12-11": {
    name: "День Данила",
    type: "religious",
    category: "Релігійні свята"
  },
"2025-12-11": {
    name: "День застосунків",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-12": {
  name: "День Сухопутних військ України",
  type: "military",
  category: "Військові свята"
},
"2025-12-12": {
  name: "День працівників роздрібної торгівлі",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-12": {
    name: "День Олександра",
    type: "religious",
    category: "Релігійні свята"
  },
"2025-12-13": {
    name: "День різдвяного светра",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-13": {
  name: "День святого Андрія",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-13": {
    name: "День какао",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-14": {
    name: "День вшанування учасників ліквідації аварії на ЧАЕС",
    type: "national",
    category: "Національні свята"
  },
"2025-12-14": {
    name: "День благодійності в Україні ",
    type: "national",
    category: "Національні свята"
  },
"2025-12-14": {
    name: "День смажених каштанів",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2025-12-14": {
    name: "День безкоштовної доставки",
    type: "fun",
    category: "Неофіційні свята"
  },
"2025-12-15": {
  name: "День працівників суду України",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-15": {
  name: "День кексів",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-15": {
  name: "День чаю",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-16": {
  name: "День - Все у шоколаді",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-16": {
  name: "День дурнуватих іграшок",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-17": {
  name: "День кленового сиропу",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-17": {
  name: "День працівника державної виконавчої служби",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-18": {
  name: "День військової контррозвідки Служби безпеки України (СБУ)",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-18": {
  name: "День вдячності сніжинці",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-18": {
  name: "День випічки печива",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-18": {
  name: "День ангела Михайла",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-19": {
  name: "День святого Миколая за григоріанським календарем",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-19": {
  name: "День адвокатури",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-19": {
  name: "День вівсяних кексів",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-19": {
  name: "День аутсайдерів",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-19": {
  name: "День потворного светра",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-20": {
  name: "День гри",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-20": {
  name: "День вшанування пенсіонерів та ветеранів МВС",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-21": {
  name: "День Державної служби зайнятості України",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-21": {
  name: "День народження баскетболу",
  type: "sports",
  category: "Спортивні свята"
    },
"2025-12-21": {
  name: "Всесвітній день сноуборду ",
  type: "sports",
  category: "Спортивні свята"
    },
"2025-12-21": {
  name: "Всесвітній день медитації ",
  type: "international",
  category: "Міжнародні дні"
    },
"2025-12-21": {
    name: "День зимового сонцестояння",
    type: "traditional",
    category: "Традиційні свята"
  },
"2025-12-21": {
    name: "День зимового сонцестояння",
    type: "traditional",
    category: "Традиційні свята"
  },
"2025-12-21": {
  name: "День ліхтарика",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-21": {
  name: "День шанування низеньких дівчат",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-22": {
  name: "День ангела Анастасії",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-22": {
  name: "День енергетика",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-22": {
  name: "День працівників дипломатичної служби України",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-22": {
  name: "День фінікового хліба",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-23": {
  name: "День військовослужбовців оперативного контролю всіх рівнів в Україні (День штабних спеціальностей і військ спеціального зв’язку)",
  type: "military",
  category: "Військові свята"
  },
"2025-12-23": {
  name: "День різдвяного кіномарафону",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-23": {
  name: "День ангела Павла",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-23": {
  name: "День внутрішнього світла",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-24": {
  name: "Святвечір",
  type: "religious",
  category: "Релігійні свята"
},
"2025-12-24": {
  name: "День ґоґоль-моґолю",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-24": {
  name: "День покупця в останню хвилину",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-24": {
  name: "День працівників архівних установ України",
  type: "professional",
  category: "Професійні свята"
},
"2025-12-25": {
  name: "Різдво Христове (за григоріанським календарем)",
  type: "major",
  category: "Великі свята"
},
"2025-12-25": {
  name: "День гарбузового пирога ",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-26": {
  name: "День листів подяки",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-27": {
    name: "День контррозвідки СБУ",
    type: "military",
    category: "Військові свята"
  },
"2025-12-27": {
  name: "День вирізання сніжинок",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-27": {
    name: "Степанів день",
    type: "religious",
    category: "Релігійні свята"
  },
"2025-12-27": {
  name: "День фруктового торта",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-28": {
  name: "Міжнародний день кіно",
  type: "cultural",
  category: "Культурні свята"
},
"2025-12-28": {
  name: "День календаря",
  type: "cultural",
  category: "Культурні свята"
},
"2025-12-28": {
  name: "День шоколадних цукерок",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-28": {
  name: "День гри в карти",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-29": {
    name: "День інформаційно-медійних структур МО та ЗСУ",
    type: "military",
    category: "Військові свята"
  },
"2025-12-30": {
  name: "День глобального планування",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-30": {
  name: "День бекону",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-31": {
  name: "Новорічна ніч",
  type: "major",
  category: "Великі свята"
},
"2025-12-31": {
  name: "Щедрий вечір, або Маланка",
  type: "traditional",
  category: "Традиційні свята"
},
"2025-12-31": {
  name: "День шампанського",
  type: "fun",
  category: "Неофіційні свята"
},
"2025-12-31": {
  name: "День прийняття рішення ",
  type: "fun",
  category: "Неофіційні свята"
},


  
  // Січень 2026

    "2026-01-01": {
      name: "Новий рік",
      type: "major",
      category: "Великі свята"
    },
    "2026-01-01": {
      name: "День похмілля",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-01": {
     name: "Всесвітній день миру",
      type: "international",
      "category" : "Міжнародні дні"
    },
    "2026-01-01": {
      name: "День родини у світі",
      type: "family",
      category: "Сімейні свята"
    },
    "2026-01-02": {
      name: "День заварних тістечок",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-02": {
      name: "День швейцарського сиру",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-02": {
      name: "Котячий новий рік",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-03": {
      name: "Міжнародний день 'Спасибі'",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-03": {
      name: "День жінок у рок-музиці",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-03": {
      name: "День вишні у шоколаді",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-03": {
      name: "Фестиваль День сну або Свято сну",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-03": {
      name: "Міжнародний день здоров'я тіла та душі",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-04": {
      name: "День позитивного ставлення до життя",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-06": {
      name: "Святий вечір (надвечір’я Різдва Христового за Юліанським календарем)",
      type: "traditional",
      category: "Традиційні свята"
    },
    "2026-01-06": {
      name: "День пісочного печива",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-06": {
      name: "Водохреще (за Григоріанським календарем)",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-06": {
      name: "День обіймів",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-06": {
      name: "День технологій",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-07": {
      name: "Різдво Христове за Юліанським календарем",
      type: "traditional",
      category: "Традиційні свята"
    },
    "2026-01-07": {
      name: "День пупса",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-07": {
      name: "Міжнародний день програміста",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-01-07": {
      name: "День наставника",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-08": {
      name: "День фотографа в Україні",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-01-08": {
      name: "День англійської іриски",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-09": {
      name: "День народження сучасного інтернету",
      type: "cultural",
      category: "Культурні свята"
    },
    "2026-01-09": {
      name: "Міжнародний день хореографа",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-01-10": {
      name: "День дошки візуалізації",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-10": {
      name: "День гіркого шоколаду",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-10": {
      name: "День своєрідних людей",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-11": {
      name: "Міжнародний день 'Дякую'",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-01-11": {
      name: "День «Вже не Новий рік»",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-11": {
        name: "День обіймів дівчаток і хлопчиків»",
        type: "fun",
        category: "Неофіційні свята"
      },
    "2026-01-12": {
      name: "День українського політв'язня",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-12": {
      name: "День гарячого чаю",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-12": {
      name: "День марципану",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-13": {
      name: "Щедрий вечір (Маланки)",
      type: "traditional",
      category: "Традиційні свята"
    },
    "2026-01-13": {
      name: "День поетичної перерви",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-13": {
      name: "День здійснення мрії",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-13": {
      name: "День гумової качки",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-14": {
      name: "Старий Новий рік",
      type: "traditional",
      category: "Традиційні свята"
    },
    "2026-01-14": {
      name: "День святителя Василія Великого",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-14": {
      name: "День «Вдягніть вашого улюбленця»",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-15": {
      name: "Всесвітній день снігу",
      type: "sports",
      category: "Спортивні свята"
    },
    "2026-01-15": {
      name: "День капелюха",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-15": {
      name: "День бублика",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-16": {
      name: "День пам’яті Кіборгів",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-16": {
      name: "Міжнародний день гострої та гарячої їжі",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-17": {
      name: "Всесвітній день піци",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-17": {
      name: "Антонів день",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-19": {
      name: "Водохреще (Хрещення Господнє за Юліанським календарем)",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-19": {
      name: "Всесвітній день домашнього сиру",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-19": {
      name: "День попкорну",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-20": {
      name: "День Автономної Республіки Крим",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-20": {
      name: "День вшанування захисників Донецького аеропорту",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-20": {
      name: "День любителів сиру",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-21": {
      name: "Міжнародний день обіймів",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-21": {
      name: "День злакового батончика",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-21": {
      name: "День «Обійми своє цуценя»",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-21": {
      name: "День ангела Максима",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-22": {
      name: "День Соборності України",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-22": {
      name: "День світлого брауні",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-22": {
      name: "День ангела Тимофія",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-24": {
      name: "Міжнародний день освіти",
      type: "educational",
      category: "Освітні свята"
    },
    "2026-01-24": {
      name: "Міжнародний жіночий спортивний день",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-01-24": {
      name: "День зовнішньої розвідки України",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-24": {
      name: "День ангела Ксенії",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-25": {
      name: "Тетянин день (у православ'ї)",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-25": {
      name: "День студента в Україні",
      type: "educational",
      category: "Освітні свята"
    },
    "2026-01-25": {
      name: "Григоріїв день",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-01-26": {
      name: "Міжнародний день митника",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-01-26": {
      name: "Міжнародний день чистої енергії",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-01-27": {
      name: "Міжнародний день пам'яті жертв Голокосту",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-01-27": {
      name: "Міжнародний день портвейну",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-28": {
      name: "День затвердження Державного герба України",
      type: "national",
      category: "Національні свята"
    },
    "2026-01-28": {
      name: "Всесвітній день безробітних",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-28": {
      name: "Міжнародний день конструктора «Лего»",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-28": {
      name: "Міжнародний день конструктора «Лего»",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-29": {
      name: "День пам'яті Героїв Крут",
      type: "military",
      category: "Військові свята"
    },
    "2026-01-29": {
      name: "День винаходу автомобіля на бензині",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-01-31": {
      name: "Міжнародний день ювеліра",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-01-31": {
      name: "Микитин день",
      type: "religious",
      category: "Релігійні свята"
    },


    // Лютий 2026

     "2026-02-01": {
      name: "Міжнародний день десерту",
      type: "fun",
      category: "Неофіційні свята"
    },
     "2026-02-02": {
      name: "День бабака",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-03": {
      name: "День годування птахів",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-03": {
      name: "День ангела Семена",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-02-03": {
      name: "День ангела Анни",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-02-03": {
      name: "День жінки-лікаря",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-02-04": {
      name: "День неандертальця",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-04": {
      name: "День ангела Миколи",
      type: "religious",
      category: "Релігійні свята"
    },
     "2026-02-05": {
      name: "Всесвітній день нутели",
      type: "fun",
      category: "Неофіційні свята"
    },
     "2026-02-06": {
      name: "Міжнародний день бармена",
      type: "fun",
      category: "Професійні свята"
    },
     "2026-02-07": {
      name: "День морозива на сніданок",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-08": {
      name: "Міжнародний день шотландського віскі",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-08": {
      name: "Всесвітній день шлюбу",
      type: "fun",
      category: "Неофіційні свята"
    },
     "2026-02-09": {
      name: "Міжнародний день піци",
      type: "fun",
      category: "Неофіційні свята"
    },
     "2026-02-09": {
      name: "День народження волейболу",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-09": {
      name: "Міжнародний день стоматолога",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-02-10": {
      name: "День замороженого йогурту",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-10": {
      name: "Всесвітній день зернобобових",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-10": {
      name: "День безпечного Інтернету",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-11": {
      name: "Міжнародний день жінок і дівчат у науці",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-11": {
      name: "День білої сорочки",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-11": {
      name: "День працівників органів РАГСу",
      type: "professional",
      category: "Професійні свята"
    },
     "2026-02-13": {
      name: "Всесвітній день радіо",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-13": {
      name: "День інтернет-друзів",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-13": {
      name: "День подруг",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-13": {
      name: "Міжнародний день шаурми",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-13": {
      name: "Мартинів день",
      type: "religious",
      category: "Релігійні свята"
    },
     "2026-02-14": {
      name: "День святого Валентина",
      type: "major",
      category: "Великі свята"
    },
    "2026-02-14": {
      name: "Міжнародний день дарування книг",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-14": {
      name: "Міжнародний день самотніх людей",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-15": {
      name: "День кіберспорту в Україні",
      type: "sports",
      category: "Спортивні свята"
    },
    "2026-02-15": {
      name: "Європейський медичної сестри",
      type: "professional",
      category: "Професійні свята"
    },
     "2026-02-16": {
      name: "Всесвітній день турботи",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-16": {
      name: "День військового журналіста України",
      type: "professional",
      category: "Професійні свята"
    },
     "2026-02-17": {
      name: "Всесвітній день спонтанного прояву доброти",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-17": {
      name: "Міжнародний день млинця",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-17": {
      name: "День кота в Європі",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-19": {
      name: "День державного герба України",
      type: "national",
      category: "Національні свята"
    },
     "2026-02-20": {
      name: "Всесвітній день соціальної справедливості",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-20": {
      name: "День Героїв Небесної Сотні",
      type: "national",
      category: "Національні свята"
    },
     "2026-02-21": {
      name: "Міжнародний день рідної мови",
      type: "international",
      category: "Міжнародні дні"
    },
     "2026-02-21": {
      name: "Всесвітній День екскурсовода",
      type: "professional",
      category: "Професійні свята"
    },
     "2026-02-22": {
      name: "Міжнародний день бойскаутів",
      type: "fun",
      category: "Неофіційні свята"
    },
     "2026-02-24": {
      name: "Іванів день",
      type: "religious",
      category: "Релігійні свята"
    },
    "2026-02-24": {
      name: "Всесвітній день бармена",
      type: "international",
      category: "Міжнародні дні"
    },
    "2026-02-25": {
      name: "День інженерно-авіаційної служби авіації ЗСУ",
      type: "professional",
      category: "Професійні свята"
    },
    "2026-02-26": {
      name: "Всесвітній день фісташок",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-26": {
      name: "День термоса",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-26": {
      name: "День цифрового навчання",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-26": {
    name: "День кримського спротиву російській окупації",
    type: "national",
    category: "Національні свята"
    },
    "2026-02-27": {
      name: "Міжнародний день оптиміста",
      type: "fun",
      category: "Неофіційні свята"
    },
    "2026-02-28": {
    name: "День штурманської служби авіації Збройних Сил",
    type: "military",
    category: "Військові свята"
    },
    "2026-02-28": {
    name: "Всесвітній день кравців",
    type: "professional",
    category: "Професійні свята"
    },





    // Березень 2026


  "2026-03-01": {
    name: "Всесвітній день компліменту",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-01": {
    name: "Всесвітній день музичної терапії",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-02": {
    name: "Всесвітній день тенісу",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-02": {
    name: "Всесвітній день музичної терапії",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-02": {
    name: "Всесвітній день психічного здоров’я підлітків",
    type: "international",
    category: "Міжнародні дні"
  },
  "2026-03-03": {
    name: "Міжнародний день ірландського віскі",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-03": {
    name: "День письменника",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-03-04": {
    name: "Всесвітній день інженерії",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-03-04": {
    name: "День боротьби з поганим обслуговуванням",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-04": {
    name: "Всесвітній день боротьби з зайвою вагою",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-05": {
    name: "Всесвітній день книги",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-03-05": {
    name: "Європейський день геодезії і геоінформації",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-03-05": {
    name: "Всесвітній день енергоефективності",
    type: "international",
    category: "Міжнародні дні"
  },
  "2026-03-06": {
    name: "День чувака",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-03-06": {
    name: "День подяки співробітникам",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-03-07": {
    name: "Всесвітній день інформаційної архітектури",
    type: "professional",
    category: "Професійні свята"
  },  
  "2026-03-08": {
    name: "Міжнародний Жіночий день",
    type: "major",
    category: "Великі свята"
  },


  "2026-03-09": {
    name: "День народження Тараса Шевченка",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-03-10": {
    name: "День Державного гімну України",
    type: "national",
    category: "Національні свята"
  },
  "2026-03-14": {
    name: "День українського добровольця",
    type: "national",
    category: "Національні свята"
  },
  "2026-03-17": {
    name: "День Святого Патрика",
    type: "international",
    category: "Міжнародні дні"
  },
  "2026-03-22": {
    name: "День таксиста",
    type: "professional",
    category: "Професійні свята"
  },

  "2026-03-25": {
    name: "День служби безпеки України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-03-26": {
    name: "День Національної гвардії України",
    type: "military",
    category: "Військові свята"
  },
  "2026-03-27": {
    name: "День нефролога",
    type: "professional",
    category: "Професійні свята"
  },

  // Квітень 2026
  "2026-04-01": {
    name: "День Сміху",
    type: "fun",
    category: "Неофіційні свята"
  },
  "2026-04-05": {
    name: "Великдень",
    type: "major",
    category: "Великі свята"
  },

  "2026-04-12": {
    name: "День працівників ракетно-космічної галузі України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-15": {
    name: "День працівників кримінального розшуку України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-17": {
    name: "День пожежної охорони",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-18": {
    name: "День пам'яток історії та культури",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-04-22": {
    name: "Міжнародний день секретаря",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-23": {
    name: "Всеукраїнський день психолога",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-26": {
    name: "День кошторисника в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-27": {
    name: "День казначейської служби України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-04-29": {
    name: "Всеукраїнський день футболу",
    type: "sports",
    category: "Спортивні свята"
  },
  "2026-04-30": {
    name: "День прикордонника",
    type: "military",
    category: "Військові свята"
  },

  // Травень 2026
  "2026-05-01": {
    name: "Свято Весни і Праці",
    type: "national",
    category: "Національні свята"
  },

  "2026-05-03": {
    name: "День кондитера",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-05-06": {
    name: "День піхоти в Україні",
    type: "military",
    category: "Військові свята"
  },
  "2026-05-07": {
    name: "День фізика",
    type: "professional",
    category: "Професійні свята"
  },

  "2026-05-09": {
    name: "День Європи в Україні",
    type: "national",
    category: "Національні свята"
  },
  "2026-05-10": {
    name: "День матері в Україні",
    type: "family",
    category: "Сімейні свята"
  },

  "2026-05-15": {
    name: "Міжнародний день сім'ї",
    type: "international",
    category: "Міжнародні дні"
  },
  "2026-05-16": {
    name: "День науки в Україні",
    type: "educational",
    category: "Освітні свята"
  },


  "2026-05-19": {
    name: "День сімейної медицини в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-05-20": {
    name: "День банківських працівників України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-05-21": {
    name: "Всесвітній день вишиванки",
    type: "cultural",
    category: "Культурні свята"
  },

  "2026-05-24": {
    name: "День слов'янської писемності і культури",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-05-25": {
    name: "День філолога",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-05-27": {
    name: "День екстреної медицини",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-05-28": {
    name: "День поліцейського офіцера громади в Україні",
    type: "professional",
    category: "Професійні свята"
  },



  // Червень 2026

  "2026-06-06": {
    name: "День журналіста України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-07": {
    name: "День працівників водного господарства України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-12": {
    name: "День працівника фондового ринку України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-14": {
    name: "День працівників текстильної і легкої промисловості",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-18": {
    name: "День дільничного офіцера поліції в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-19": {
    name: "День фермера",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-21": {
    name: "День медичного працівника",
    type: "professional",
    category: "Професійні свята"
  },
 
  "2026-06-23": {
    name: "День державної служби України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-25": {
    name: "День митної служби України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-26": {
    name: "День національного прапора кримських татар в Україні",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-06-27": {
    name: "День винахідника і раціоналізатора",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-06-28": {
    name: "День Конституції України",
    type: "major",
    category: "Великі свята"
  },

  // Липень 2026
  "2026-07-01": {
    name: "День слідства в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-02": {
    name: "День податківця України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-04": {
    name: "День Національної поліції України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-05": {
    name: "День Військово-Морських Сил Збройних Сил України",
    type: "military",
    category: "Військові свята"
  },
  "2026-07-08": {
    name: "День родини",
    type: "family",
    category: "Сімейні свята"
  },
  "2026-07-12": {
    name: "День рибалки",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-15": {
    name: "День Української Державності",
    type: "national",
    category: "Національні свята"
  },
  "2026-07-16": {
    name: "День бухгалтера України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-19": {
    name: "День металурга",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-20": {
    name: "День шахів в Україні",
    type: "sports",
    category: "Спортивні свята"
  },
  "2026-07-24": {
    name: "День фінансового працівника в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-26": {
    name: "День працівників торгівлі",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-07-27": {
    name: "День медичного працівника України",
    type: "professional",
    category: "Професійні свята"
  },

  "2026-07-29": {
    name: "День Сил спеціальних операцій Збройних Сил України",
    type: "military",
    category: "Військові свята"
  },
  "2026-07-31": {
    name: "День системного адміністратора",
    type: "professional",
    category: "Професійні свята"
  },

  // Серпень 2026
  "2026-08-01": {
    name: "День інкасатора",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-08-02": {
    name: "День Повітряних Сил Збройних Сил України",
    type: "military",
    category: "Військові свята"
  },
  "2026-08-06": {
    name: "Преображення Господнє",
    type: "religious",
    category: "Релігійні свята"
  },
  "2026-08-08": {
    name: "День військ зв'язку України",
    type: "military",
    category: "Військові свята"
  },
  "2026-08-09": {
    name: "День будівельника",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-08-14": {
    name: "Медовий Спас",
    type: "religious",
    category: "Релігійні свята"
  },
  "2026-08-19": {
    name: "День пасічника України",
    type: "professional",
    category: "Професійні свята"
  },

  "2026-08-23": {
    name: "День Державного Прапора України",
    type: "national",
    category: "Національні свята"
  },
  "2026-08-24": {
    name: "День Незалежності України",
    type: "major",
    category: "Великі свята"
  },
  "2026-08-27": {
    name: "День сала в Україні",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-08-29": {
    name: "День авіації України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-08-30": {
    name: "День шахтаря",
    type: "professional",
    category: "Професійні свята"
  },

  // Вересень 2026
  "2026-09-01": {
    name: "День знань",
    type: "educational",
    category: "Освітні свята"
  },

  "2026-09-06": {
    name: "День підприємця України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-07": {
    name: "День воєнної розвідки України",
    type: "military",
    category: "Військові свята"
  },
  "2026-09-08": {
    name: "Різдво Діви Марії",
    type: "religious",
    category: "Релігійні свята"
  },
  "2026-09-09": {
    name: "День дизайнера графіка в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-12": {
    name: "День українського кіно",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-09-13": {
    name: "День працівників нафтової, газової та нафтопереробної промисловості",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-14": {
    name: "День танкових військ",
    type: "military",
    category: "Військові свята"
  },
  "2026-09-17": {
    name: "День працівників цивільного захисту України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-19": {
    name: "День фармацевтичного працівника України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-20": {
    name: "Всенародний День Батька",
    type: "family",
    category: "Сімейні свята"
  },
  "2026-09-21": {
    name: "День миру",
    type: "international",
    category: "Міжнародні дні"
  },

  "2026-09-25": {
    name: "День позашкілля в Україні",
    type: "educational",
    category: "Освітні свята"
  },
  "2026-09-27": {
    name: "День туризму в Україні",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-09-29": {
    name: "День отоларинголога",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-09-30": {
    name: "Всеукраїнський День бібліотек",
    type: "cultural",
    category: "Культурні свята"
  },

  // Жовтень 2026
  "2026-10-01": {
    name: "День захисника України",
    type: "national",
    category: "Національні свята"
  },
  "2026-10-02": {
    name: "День працівників професійно технічної освіти",
    type: "educational",
    category: "Освітні свята"
  },
  "2026-10-04": {
    name: "День працівників освіти",
    type: "major",
    category: "Великі свята"
  },
  "2026-10-05": {
    name: "День працівників карного розшуку",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-10-08": {
    name: "День юриста України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-10-09": {
    name: "День ріелтора в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-10-10": {
    name: "День працівників стандартизації та метрології України",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-10-11": {
    name: "День художника України",
    type: "cultural",
    category: "Культурні свята"
  },
  "2026-10-12": {
    name: "День економіста в Україні",
    type: "professional",
    category: "Професійні свята"
  },
  "2026-10-13": {
    name: "День святителя Михайла",
    type: "religious",
    category: "Релігійні свята"
  }
};




// Функція для отримання свят за категорією
export const getHolidaysByCategory = (category) => {
  const holidays = [];
  
  Object.keys(ukrainianHolidays).forEach(dateKey => {
    const holiday = ukrainianHolidays[dateKey];
    if (holiday.category === category) {
      holidays.push({
        date: dateKey,
        ...holiday
      });
    }
  });
  
  return holidays.sort((a, b) => a.date.localeCompare(b.date));
};

// Функція для отримання найближчих свят
export const getUpcomingHolidays = (daysAhead = 30) => {
  const today = new Date();
  const endDate = new Date(today.getTime() + daysAhead * 24 * 60 * 60 * 1000);
  const holidays = [];
  
  Object.keys(ukrainianHolidays).forEach(dateKey => {
    const holidayDate = new Date(dateKey);
    if (holidayDate >= today && holidayDate <= endDate) {
      holidays.push({
        date: dateKey,
        ...ukrainianHolidays[dateKey]
      });
    }
  });
  
  return holidays.sort((a, b) => a.date.localeCompare(b.date));
};

// Категорії свят
export const holidayCategories = [
  "Великі свята",
  "Національні свята",
  "Релігійні свята",
  "Професійні свята",
  "Військові свята",
  "Культурні свята",
  "Сімейні свята",
  "Освітні свята",
  "Спортивні свята",
  "Міжнародні дні",
  "Неофіційні свята"
];

// Функція для отримання українського тексту типу свята
export const getHolidayTypeText = (type) => {
  const typeMap = {
    'major': 'Велике свято',
    'national': 'Національне свято',
    'religious': 'Релігійне свято',
    'professional': 'Професійне свято',
    'military': 'Військове свято',
    'cultural': 'Культурне свято',
    'historical': 'Історична дата',
    'memorial': 'День пам\'яті',
    'family': 'Сімейне свято',
    'educational': 'Освітнє свято',
    'sports': 'Спортивне свято',
    'international': 'Міжнародний день',
    'social': 'Соціальний день',
    'fun': 'Неофіційне свято',
    'city': 'День міста',
    'environmental': 'Екологічний день',
    'awareness': 'День боротьби',
    'governmental': 'Державне свято'
  };
  return typeMap[type] || 'Свято';
};

export default ukrainianHolidays;
